import dayjs from 'dayjs';
import { whiteLabelStore } from 'Models/WhiteLabelStore';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import {
	switchToPassengerWizardData,
	switchToVehicleWizardData,
} from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/Sidebar/FerryFilters/PassengerDetails/BookingTypeButtons';
import { BulkBookingDetailsState, BulkBookingFilters } from './Types';

export const switchToBulkBookingModeWizardData = (wizardData: BookingWizardData) => {
	const newWizardData = new BookingWizardData({
		...wizardData,
		bulkBookingFilters: getInitialBulkBookingFilters(),
	});

	// We do not support bulk booking for freight (yet)
	if (wizardData.tabSelected === 'freight') {
		if (whiteLabelStore.defaultBookingType === 'passenger') {
			switchToPassengerWizardData(newWizardData, wizardData);
		}
		if (whiteLabelStore.defaultBookingType === 'vehicle') {
			switchToVehicleWizardData(newWizardData, wizardData);
		}
	}

	return newWizardData;
};

export const exitBulkBookingModeWizardData = (wizardData: BookingWizardData) => {
	return new BookingWizardData({ ...wizardData, bulkBookingFilters: undefined });
};

export const getInitialBulkBookingDetailsState = (): BulkBookingDetailsState => ({
	startDate: dayjs().startOf('day').toDate(),
	endDate: null,
	// Weekly every week is what bulk booking did before the pattern became configurable, so it
	// stays the default and the extra inputs only matter to the people who change it.
	frequency: 'weekly',
	interval: 1,
	daysOfWeek: [],
	weekOrdinals: [],
	departureTime: dayjs().startOf('day').toDate(),
});

export const getInitialBulkBookingFilters = (): BulkBookingFilters => {
	return {
		...getInitialBulkBookingDetailsState(),
		tripIds: [],
	};
};
